import React, { Component } from 'react'
import axios from 'axios'

class UserForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      name: '',
      project: '',
      contact: '',
      done: false,
      active: true,
      error: false,
    }
  }

  onChange = e => {
    this.setState({ [e.target.name]: e.target.value })
    this.props.onChange(e.target.name, e.target.value)
  }

  onSubmit = async e => {
    e.preventDefault()
    this.setState({ active: false })
    const { name, project, contact } = this.state
    const url = 'https://hooks.slack.com/services/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'

    const text =
      'Hello ganztags., my name is ' +
      name +
      ' and i need help with ' +
      project +
      '. Please contact me at ' +
      contact +
      '.'

    try {
      await axios({
        method: 'post',
        url: url,
        headers: { 'Content-Type': 'multipart/form-data' },
        data: {
          text: text,
        },
      })
      this.setState({ done: true })
    } catch (e) {
      this.setState({ error: true })
      console.log(e.response)
    }
  }

  render() {
    const { name, project, contact } = this.state
    return (
      <form id="contactform" onSubmit={this.onSubmit}>
        <div className="form-group">
          <input
            aria-label="Your Name"
            type="text"
            className="form-control"
            id="input_name"
            name="name"
            placeholder="Your Name"
            value={name}
            required
            onChange={this.onChange}
          />
        </div>
        <div className="form-group">
          <input
            aria-label="Project or Website"
            type="text"
            className="form-control"
            id="input_projekt"
            name="project"
            placeholder="Project or Website"
            value={project}
            required
            onChange={this.onChange}
          />
        </div>
        <div className="form-group">
          <input
            aria-label="Contact details (e-mail or phone number)"
            type="text"
            className="form-control"
            id="input_email"
            name="contact"
            placeholder="Contact details (e-mail or phone number)"
            value={contact}
            required
            onChange={this.onChange}
          />
        </div>

        {this.state.active ? (
          <button type="submit" className="btn btn-primary text-uppercase p-2 pl-3 pr-3 mt-3" id="submit">
            SEND
          </button>
        ) : null}
        {this.state.done ? (
          <p className="text-success small mt-2">
            <i className="fa fa-check"></i> Vielen Dank für Ihre Anfrage! Wir melden uns schnellstmöglich.
          </p>
        ) : null}
      </form>
    )
  }
}

export default UserForm
